<div class="input-container">
  <span
    class="form-control-label"
    [ngClass]="{
      'text-red-error': hasError,
      'disabled': disabled,
    }"
    ><span *ngIf="required">*</span>{{ label }}</span
  >
  <div class="flex relative w-full">
    <ng-content></ng-content>
    <div
      *ngIf="hasError"
      class="error-icon"
      [ngClass]="{ '!right-10': adjustErrorIcon }"
    >
      <fa-icon [icon]="faCircleExclamation" class="text-red-error"> </fa-icon>
    </div>
    <span class="ml-1 mr-3 unit-of-measure">{{ unitOfMeasure }}</span>
  </div>
  <span class="tooltip" [attr.data-tip]="tooltip">
    <fa-icon
      *ngIf="!removeExclamationIcon"
      [icon]="faCircleInfo"
      class="text-2xl text-dark-40 ml-4"
      [class.invisible]="hideExclamationIcon"
    ></fa-icon>
  </span>
</div>
